














































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import {
  NavBar,
  Image,
  Icon,
  Row,
  Swipe,
  SwipeItem,
  Stepper,
  Tab,
  Tabs,
} from "vant";
import Screen from "./Details/screen.vue";
import RemainStock from "./Details/RemainStock.vue";
import { monitorEvent } from "@/utils/youMengMonitor";
import { zhugeTrack } from "@/utils";
@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Stepper.name]: Stepper,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Screen,
    RemainStock,
  },
})
export default class MallDetails extends Mixins(Mixin) {
  dataInfo = {
    //弹窗规格
    show: false,
    order: {
      commodityInfoId: this.$route.query.commodityId,
      num: 1,
      specsRelationId: "",
      remainStock: 0,
    },
  };
  pur = 0; //限购
  stockInfo = {
    num: 1,
    remainStock: 1, //库存
    isShow: false,
  };
  current = 0; //当前轮播下标
  scrollTop = 0;
  active = 1;
  navHeight = 0; //顶部nav高度
  mallInfo: good.CommodityDto = {}; //商场信息
  commodityId: string | (string | null)[] = "";
  //会员id
  get memberLevelId(): string {
    return this.UserModule.memberLevelId || "0";
  }
  mounted(): void {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    this.stockInfo.num = 1;
    this.commodityId = this.$route.query.commodityId;
    this.navHeight = (
      document.getElementById("mallNav") as HTMLElement
    ).offsetHeight;

    this.getInfo();
    window.addEventListener("scroll", this.handleScroll);
  }

  beforeDestroy(): void {
    window.removeEventListener("scroll", this.handleScroll);
  }
  //富文本图片处理
  dealPicture(desc: string): string {
    return desc
      ? desc.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      : "";
  }
  //处理时间
  timeFilter(show: boolean, time?: string): string {
    if (!time) {
      return "00:00:00";
    }
    let date = new Date(time);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let month: number | string = "";
    let days: number | string = "";
    let hours: number | string = "";
    month = m < 10 ? "0" + m : m;
    let d = date.getDate();
    days = d < 10 ? "0" + d : d;
    let h = date.getHours();
    hours = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    // let second = date.getSeconds();
    let min = minute < 10 ? "0" + minute : minute;
    // s = second < 10 ? "0" + second : second;
    if (show == false) {
      return y + "." + month + "." + days;
    } else {
      return y + "." + month + "." + days + " " + hours + ":" + min;
    }
  }

  /*
   *弹窗规格
   */
  showSpecification(): void {
    if (this.mallInfo.status === "01" || this.mallInfo.status === "05") {
      this.dataInfo.show = true;
    }
  }

  /*
   *按钮名称
   */
  btnName(value?: string): string {
    let name = "";
    if (value == "01") {
      name = "立即购买";
    } else if (value == "02") {
      name = "已下架";
    } else if (value == "03") {
      name = "即将开售";
    } else if (value == "04") {
      name = "已结束";
    } else if (value == "05") {
      name = "补货中";
      // if (this.mallInfo.commoditySpecs!.length > 1) {
      //   name = "立即购买";
      // } else {
      //   if (this.mallInfo.outStockRegister) {
      //     name = "立即购买";
      //   } else {
      //     name = "立即购买";
      //   }
      // }
    } else {
      name = "立即购买";
    }
    return name;
  }
  //页面滚动事件监听
  handleScroll(): void {
    this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop; // 滚动条偏移量
  }
  //返回
  onClickLeft(): void {
    this.$router.go(-1);
  }
  //滑动轮播
  onChange(index: number): void {
    this.current = index;
  }

  /*
   * 按钮的判断
   */
  isShowstock(mallInfo: good.CommodityDto): boolean {
    let isShow = true;
    if (mallInfo.status === "01") {
      isShow = false;
    } else if (mallInfo.status === "05") {
      if (this.mallInfo.commoditySpecs!.length > 1) {
        //多规格让他弹窗可以点击
        isShow = true;
      } else {
        if (this.mallInfo.outStockRegister) {
          //有用户缺货登记的商品可以点击
          isShow = true;
        } else {
          isShow = true;
        }
      }
    }

    return isShow;
  }
  /*
   * 获取详情信息
   */
  getInfo(): void {
    this.$api.goodApi.commodity.getCommodityDetail(
      Number(this.commodityId),
      ({ data }) => {
        let obj: good.CommodityDto = data;
        let isMember = false;
        zhugeTrack("积分商品浏览", {
          商品名称: data.commodityTitle,
        });
        if (obj.lowestMemberPrices) {
          isMember = obj.lowestMemberPrices.some((item) => {
            return item.memberGradeId === this.memberLevelId;
          });
          if (isMember) {
            obj.lowestMemberPrices = obj.lowestMemberPrices.filter((item) => {
              return item.memberGradeId === this.memberLevelId;
            });
          } else {
            obj.lowestMemberPrices = obj.lowestMemberPrices.filter((item) => {
              return item.memberGradeId === "0";
            });
          }
        }

        this.pur = obj.limitNum ? obj.limitNum : 0;
        this.stockInfo.remainStock = 0;
        if (obj.commoditySpecs && obj.commoditySpecs.length > 0) {
          if (obj.commoditySpecs[0].remainStock! > 0) {
            this.stockInfo.remainStock = Number(
              obj.commoditySpecs[0].remainStock
            );
          } else {
            this.stockInfo.remainStock = 0;
          }
        }
        this.mallInfo = obj;
      }
    );
  }
  /*
   * 去图片详情页
   */
  goImgDetails(): void {
    let image = JSON.stringify(this.mallInfo.commoditiesPicture);
    this.$router.push(`/mall/details-img?url=${image}`);
  }
  /*
   * 立即购买
   */
  goOrder(): void {
    if (this.mallInfo.status == "01") {
      //有规格选择时
      if (
        this.mallInfo.commoditySpecs &&
        (this.mallInfo.commoditySpecs.length > 1 ||
          (this.mallInfo.commoditySpecs[0].commoditySpecsDetails &&
            this.mallInfo.commoditySpecs[0].commoditySpecsDetails.length > 1))
      ) {
        this.dataInfo.show = true;
        return;
      }
      this.getSpecs();
    } else if (this.mallInfo.status == "05") {
      return;
      // //缺货登记
      // if (this.UserModule.isLogin) {
      //   if (this.mallInfo.commoditySpecs!.length > 1) {
      //     this.dataInfo.show = true;
      //     return;
      //   } else {
      //     if (this.mallInfo.outStockRegister) {
      //       this.OutStock();
      //     } else {
      //       return;
      //     }
      //   }
      // } else {
      //   this.RouteRecordModule.GO_TO_LOGIN_PAGE_PERSIST({
      //     router: this.$router,
      //     newPage: true,
      //     goBackAfterLogin: true,
      //   });
      // }
    } else {
      return;
    }
  }
  /*
   * 提交信息
   */
  getSpecs(): void {
    let specsRelationId = this.mallInfo.commoditySpecs
      ? this.mallInfo.commoditySpecs[0].specsRelationId
      : "";
    let Specification = ""; //埋点的规格信息
    if (
      this.mallInfo.commoditySpecs &&
      this.mallInfo.commoditySpecs[0].commoditySpecsDetails &&
      this.mallInfo.commoditySpecs[0].commoditySpecsDetails.length > 0
    ) {
      let specsTypeName =
        this.mallInfo.commoditySpecs[0].commoditySpecsDetails[0]
          .specsTypeName || "";
      let specsName =
        this.mallInfo.commoditySpecs[0].commoditySpecsDetails[0].specsName ||
        "";
      Specification = specsTypeName + ":" + specsName;
    }
    let activityOrderId = this.$route.query.activityOrderId
      ? String(this.$route.query.activityOrderId)
      : "";
    this.$api.orderApi.goodOrder.createGoodAdvance(
      {
        activityOrderId: activityOrderId,
        commodityInfoId: Number(this.$route.query.commodityId),
        num: this.stockInfo.num,
        specsRelationId: specsRelationId,
      },
      ({ data }) => {
        //埋点：商品详情，点击立即购买
        monitorEvent("GoodDetail_ClickBuy", "点击立即购买", Specification);
        this.$router.push(
          `/mall/confirm-order?uuid=${data}&activityOrderId=${activityOrderId}`
        );
      }
    );
  }
  /*
   * 缺货登记
   */
  OutStock(): void {
    let commodityInfoId = this.$route.query.commodityId;
    let specsRelationId = this.mallInfo.commoditySpecs
      ? this.mallInfo.commoditySpecs[0].specsRelationId
      : "";
    this.$api.memberApi.record.userLackCommodityRecord(
      Number(commodityInfoId),
      specsRelationId!,
      () => {
        this.$toast("提交成功");
      },
      (error) => {
        error && this.$toast(error);
      }
    );
  }
}
